import { useMemo, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import ResizePanel from 'react-resize-panel-ts';

import * as K from 'common/constants';
import { truncateText } from 'common/util/string';
import { TOKEN_TYPE } from 'common/util/filter/types';

import Page from 'components/common/Page/Page';
import SearchToolbar from 'components/search/SearchToolbar';
import Sidebar from 'components/search/Sidebar/Sidebar';
import SidebarToggle from 'components/search/Sidebar/SidebarToggle';
import { settingsState } from 'components/common/Managers/SettingsManager.state';
import { useResizeRegistration } from 'components/common/Managers/LayoutStateManager';
import { completeFilterState } from 'components/common/Managers/RouteStateManager.state';

import GraphResultsToolbar from './GraphResultsToolbar';
import GraphStateManager from './GraphStateManager';
import GraphResultsContainer from './GraphResultsContainer';
import './SearchGraphsPage.scss';

/**
 * SearchGraphsPage component. Composes the page component and necessary components that make up the Search graphs Page.
 * It is responsible for making requests to the server/cache for graph page related data.
 */
function SearchGraphsPage(): JSX.Element {

  // TODO: get plot data from LRQ and properly construct series data.
  const settings = useRecoilValue(settingsState);
  const sideBarContainerRef = useResizeRegistration();
  const sidebarToggleRef = useRef(null);
  const completeFilter = useRecoilValue(completeFilterState);
  const title = truncateText(completeFilter, K.TITLE_MAX_LENGTH) || 'Graph';

  const excludeTypes = useMemo(() => [ TOKEN_TYPE.COMMAND ], []);

  return (
    <Page docTitle={title} type="full">
      <GraphStateManager />
      <SearchToolbar excludeTypes={excludeTypes} />
      <div className="SearchGraphs__ResultsArea">
        <div ref={sideBarContainerRef} className="SearchLogs__SidebarContainer" data-resize-id={K.RESIZE_ID.SEARCH_LOGS_SIDEBAR}>
          {settings[K.SETTING.SHOW_SIDEBAR] ? <ResizePanel direction="e" handleClass='SearchLogsResultsArea__ResizeCustomHandle'>
          <div className="SearchLogsResultsArea__Sidebar">
            <Sidebar mode={K.EVENT_MODE.GRAPH}/>
            <SidebarToggle toggleRef={sidebarToggleRef} />
          </div>
        </ResizePanel> :
          <SidebarToggle toggleRef={sidebarToggleRef} />}
        </div>

        <div className="SearchGraphs__ResultsContainer">
          <GraphResultsToolbar  />
          <div className="SearchGraphs__GraphContainer">
            <GraphResultsContainer />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default SearchGraphsPage;
